import script from "./gmPay.vue?vue&type=script&setup=true&lang=js"
export * from "./gmPay.vue?vue&type=script&setup=true&lang=js"

import "./gmPay.vue?vue&type=style&index=0&id=1b17137e&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b17137e"]])

export default __exports__